<template>
  <div class="search">
    <div class="search-bar">
      <div class="search-type">
        <p>Products</p>
      </div>
      <div class="search-input">
        <input type="text" placeholder="Search for products, grades, brands, CAS, manufacturers"
          @focus="showHistoryAction" @blur="hideHistoryAction" @keydown="searchAction" v-model="modelKeyword" />
        <img class="search-icon" src="../../assets/images/icon-search2.png" alt="" @click="searchByBtnAction">
      </div>
    </div>
    <!-- <div class="search-list" v-show="searchListVisible">
      <ul>
        <li v-for="(item, index) in historyList" :key="'search-history-item' + index" @click="goToSearchResult(item)">
          {{ item }}</li>
      </ul>
    </div>
    <div class="mask" v-show="searchListVisible" @click="closeAllPopup"></div> -->
  </div>
</template>

<script>
  import { getStorage, setStorage } from '../../utils/storage.js';
  export default {
    props: {
      attrKeyword: {
        type: String
      },
      callback: {
        type: Function
      }
    },
    data() {
      return {
        searchListVisible: false, // 搜索列表可视化
        historyList: [], // 历史记录
        modelKeyword: this.attrKeyword || '' // 搜索关键字
      }
    },
    mounted() {
      this.getHistory();
    },
    methods: {
      // 获取历史记录
      getHistory() {
        let storage = getStorage('searchHistory')
        if (storage) {
          this.historyList = storage;
        }
      },
      // 关闭所有弹层
      closeAllPopup() {
        this.searchListVisible = false;
      },
      // 搜索
      searchAction(e) {
        if (e.keyCode === 13) {
          this.searchHandle();
        }
      },
      // 搜索处理
      searchHandle() {
        if (this.modelKeyword != '') {
          this.historyList.unshift(this.modelKeyword);
          if (this.historyList.length > 5) {
            this.historyList.pop();
          }
          setStorage('searchHistory', this.historyList);
        }
        if (this.callback) {
          this.callback(this.modelKeyword);
        } else {
          this.$router.push({ path: '/search/result', query: { keyword: this.modelKeyword } });
        }
      },
      // 显示历史记录
      showHistoryAction() {
        this.searchListVisible = true;
      },
      // 因此历史记录
      hideHistoryAction() {
        this.searchListVisible = false;
      },
      /**
       * 跳转到搜索结果页面
       * @param {Object} searchValue 搜索内容
       */
      goToSearchResult(searchValue) {
        if (this.callback) {
          this.callback(searchValue);
        } else {
          this.$router.push({ path: '/search/result', query: { keyword: searchValue } });
        }
      },
      // 搜索图标搜索
      searchByBtnAction() {
        this.searchHandle();
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .search {
    position: relative;
    z-index: 1;

    .mask {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }
  }

  .search-bar {
    display: flex;
    align-items: center;
    background-color: #eaedf7;
    border-radius: 20rem;
    padding: 1rem;
    height: 2rem;
    line-height: 2rem;
    margin: 0 2rem;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .4);

    .search-type {
      border-right: 1px solid #b9c0d4;
      width: 22%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      color: #999;

      img {
        display: block;
        width: 1rem;
        margin-left: .5rem;
      }
    }

    .search-input {
      border-left: 1px solid #fff;
      flex: 1;
      display: flex;
      align-items: center;

      input {
        display: block;
        width: 100%;
        padding: 0 .5rem;
        box-sizing: border-box;
        background: none;
        border: 0;
        outline: none;

        &::placeholder {
          color: #999;
        }
      }

      .search-icon {
        diplay: block;
        width: 1.6rem;
        margin-right: .5rem;
      }
    }
  }

  .search-list {
    position: absolute;
    z-index: 10;
    top: 5.2rem;
    left: 2rem;
    right: 2rem;
    background-color: #eaedf6;
    border-radius: 1rem;
    box-shadow: 0 0 4px rgba(0, 0, 0, .6);
    height: 17rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    ul {
      padding: 1rem 2rem;

      li {
        font-size: 1.5rem;
        color: #666;
        line-height: 3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/search.vue